import React, { Component } from "react";
import DateField from "./DateField";
import FileField from "./FileField";
import PhoneField from "./PhoneField";
import SelectField from "./SelectField";
import TextArea from "./TextArea";
import TextField from "./TextField";
import LinkSelectField from "./LinkSelectField";
import CheckboxField from "./CheckboxField";
import CheckboxGroup from "./CheckboxGroup";
import RadioField from "./RadioField";
import RadioGroup from "./RadioGroup";
import SignatureField from "./SignatureField";

class InputField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: this.props?.type ?? null,
    };
  }

  componentWillUnmount() {
    this.props.unregister(this.props.name);
  }

  render() {
    switch (this.state.type) {
      case "text":
      case "email":
      case "number":
        return <TextField {...this.props}></TextField>;
      case "date":
        return <DateField {...this.props}></DateField>;
      case "select":
        return <SelectField {...this.props}></SelectField>;
      case "phone":
        return <PhoneField {...this.props}></PhoneField>;
      case "textarea":
        return <TextArea {...this.props}></TextArea>;
      case "file":
        return <FileField {...this.props}></FileField>;
      case "linkSelect":
        return <LinkSelectField {...this.props}></LinkSelectField>;
      case "checkbox":
        return <CheckboxField {...this.props}></CheckboxField>;
      case "checkbox-group":
        return <CheckboxGroup {...this.props}></CheckboxGroup>;
      case "radio":
        return <RadioField {...this.props}></RadioField>;
      case "radio-group":
        return <RadioGroup {...this.props}></RadioGroup>;
      case "signature":
        return <SignatureField {...this.props}></SignatureField>;
      default:
        return <>no field selected</>;
    }
  }
}

export default InputField;
